/* eslint-disable */
import { IAnswerSchema } from '../answer/AnswerSchema';
import { IFieldSizeSchema } from '../field_size/FieldSizeSchema';

export interface IQuestionFieldSchema {
  /** Значения для вопросов с вариантами ответов **/
  answers?: IAnswerSchema[] | null;
  /** Автоматический фокус поля **/
  autoFocus?: boolean | null;
  /** Маска ввода **/
  mask?: string | null;
  /** Имя поля, в которое складывается ответ **/
  name: EName;
  /** Плейсхолдер **/
  placeholder?: string | null;
  /** Префикс поля. Пример: «от» **/
  prefix?: string | null;
  /** Размер поля в сетке 1 - 12 **/
  size?: IFieldSizeSchema | null;
  /** Подтип вопроса, например для задания типа отображения **/
  subType?: ESubType | null;
  /** Тип поля шага, может быть перекрыт кастомными полями **/
  type: EType;
  /** Единица измерения **/
  unit?: string | null;
}
export enum EName {
  /** Адрес объекта/Кадастровый номер **/
  'AddressCadastre' = 'addressCadastre',
  /** Оставьте ваш адрес электронной почты **/
  'ApplicantEmail' = 'applicantEmail',
  /** Как вас зовут? **/
  'ApplicantName' = 'applicantName',
  /** Оставьте ваш номер мобильного телефона **/
  'ApplicantPhone' = 'applicantPhone',
  /** Загрузите фото правоустанавливающего документа на {object_type} **/
  'EntitlementDocument' = 'entitlementDocument',
  /** Какую недвижимость хотите проверить? **/
  'ObjectType' = 'objectType',
  /** Приложите другие документы **/
  'OtherDocuments' = 'otherDocuments',
  /** Загрузите фото паспорта собственника {object_type} **/
  'SellerPassport' = 'sellerPassport',
}
export enum ESubType {
  /** Строгая проверка адреса **/
  'AddressStrict' = 'addressStrict',
  /** Иконки **/
  'Icon' = 'icon',
  /** Картинки **/
  'Pictures' = 'pictures',
}
export enum EType {
  /** Поле для ввода адреса с саджестом **/
  'Address' = 'address',
  /** Ввод адреса объекта/кадастрового номера **/
  'AddressCadastre' = 'addressCadastre',
  /** Поле в виде чекбокса **/
  'Checkbox' = 'checkbox',
  /** Дата **/
  'Date' = 'date',
  /** Файл **/
  'File' = 'file',
  /** Поле ввода для числа с плавающей точкой **/
  'Float' = 'float',
  /** ФИО **/
  'FullName' = 'fullName',
  /** Ввод Гео данных, таких как регион, город, район, метро **/
  'Geo' = 'geo',
  /** Ввод города **/
  'GeoCity' = 'geoCity',
  /** Поле ввода для целого числа **/
  'Integer' = 'integer',
  /** Ввод строки по маске **/
  'Masked' = 'masked',
  /** Выбор нескольких вариантов **/
  'MultiChoice' = 'multiChoice',
  /** Несколько файлов **/
  'MultipleFiles' = 'multipleFiles',
  /** Выбор одного варианта **/
  'OneChoice' = 'oneChoice',
  /** Ввод номера телефона **/
  'Phone' = 'phone',
  /** Поле ввода для цены **/
  'Price' = 'price',
  /** Простое поле ввода **/
  'String' = 'string',
  /** Поле в виде textArea **/
  'TextArea' = 'textArea',
}
